import { Component } from '@angular/core';
import { DashboardClusterDetails } from '../dashboard-modals.models';

declare let $: any;

@Component({
  selector: 'app-dashboard-cluster-details-modal',
  templateUrl: './cluster-details-modal.component.html',
})
export class DashboardClusterDetailsModalComponent {
  vehicle?: DashboardClusterDetails;

  open(vehicle: DashboardClusterDetails): void {
    this.vehicle = vehicle;
    $('#carCluster').modal('show');
  }
}
